<template>
  <div class="animated fadeIn arpaymfrm">
    <b-card>
      <div slot="header">{{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <label><strong>Detail Refund </strong></label>
      <b-row>
        <b-col lg="8">
          <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">Refund No. </label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.settleno"
                  :state="!$v.model.settleKey.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-prepend><span class="p-2">Refund Date</span></b-input-group-prepend>
                <b-form-input v-model="model.tglsettl" disabled ></b-form-input>
              </b-input-group>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">CIF | Nm. Debitur</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.custinfo"
                ></b-form-input>
                
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="p-2">Kolektor</span></b-input-group-prepend
                >
                <b-form-select
                  v-model="model.collector_id"
                  :plain="true"
                  :options="collectors"
                  disabled="disabled"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">No Agreement</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                ></b-form-input>
                
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="p-2">No Kontrak</span></b-input-group-prepend
                >
                 <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label class="label-md"></label>
            </b-input-group-prepend>
            <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a>
          </b-input-group> -->
          <b-input-group>
            <span class="pt-2 pr-2">Kelompok Pembayaran</span>
            <span v-if="model.paym_group == 'WO'" class="input-group-text">WO</span>
            <span v-else class="input-group-text">Normal</span>
          </b-input-group>  
          <b-input-group>
            <b-input-group-prepend>
              <label class="label-md">Keterangan / <br />Catatan</label>
            </b-input-group-prepend>
            <b-form-textarea
              :rows="2"
              :max-rows="5"
              v-model="model.settleuraian"
              disabled            
            ></b-form-textarea>
          </b-input-group>
           <b-input-group >
            <b-input-group-prepend
              ><label
                >Refund Amt</label
              ></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                uanguser
              }}</span></b-input-group-prepend
            >
            <div style="width: 170px">
               <my-number
                class="form-control text-right my-number bg-warning text-dark"
                separator=","
                v-model="model.settleamt"
                :precision="2"
                :minus="true"
                readonly
                
              ></my-number>
            </div>
           
          </b-input-group>
        </b-col>
       
      </b-row>
      <hr />
      <label><strong>Detail Disbursement </strong></label>

      <b-row>
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label class="label-md">Trx Bank No.</label></b-input-group-prepend>
              <b-form-input v-model="model.nomor" readonly></b-form-input>
              <b-input-group-prepend><span class="p-2">Payment Date</span></b-input-group-prepend>
              <b-form-input v-model="model.tglpaym" type="date" :state="!$v.model.tglpaym.$error"></b-form-input>
          </b-input-group>
         
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend
              ><label>Disbursement Amt.</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <div style="width: 170px">
              <my-number
                class="form-control text-right my-number"
                separator=","
                v-model="model.disburmentamt"
                :precision="2"
                :state="!$v.model.disburmentamt.$error"
              ></my-number>
            </div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Bank Charges</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <div style="width: 170px">
              <my-number
                class="form-control text-right my-number"
                separator=","
                v-model="model.bcharges"
                :precision="2"
              ></my-number>
            </div>
          </b-input-group>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Payment Method</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="model.jenis"
                  :plain="true"
                  :options="jenisPaym"
                  :state="!$v.model.jenis.$error"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Due/Efective Date</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tgl_terima"
                  type="date"
                  :state="!$v.model.tgl_terima.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              lg="6"
              v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><label>Cheque/Giro No.</label></b-input-group-prepend
                >
                <b-form-input v-model="model.nomorcek"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col
              lg="6"
              v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><label>Cheque/Giro Date</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tgl_giro"
                  type="date"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" >
              <b-input-group>
                <b-input-group-prepend
                  ><label>Finance Account</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.namabank"
                  @keyup.13.native="lkuBankaccountShow = true"
                  :state="!$v.model.namabank.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-append>
                  <span class="input-group-text" style="width: 60px">{{
                    model.matauang
                  }}</span>
                </b-input-group-append>
              </b-input-group>
              <b-input-group v-if="this.model.isbank == '1'">
                <b-input-group-prepend
                  ><label>Bank Account#</label></b-input-group-prepend
                >
                <b-form-input disabled v-model="model.nomorrek"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-md">Keterangan / <br />Catatan</label>
                </b-input-group-prepend>
                <b-form-textarea
                  :rows="2"
                  :max-rows="5"
                  v-model="model.uraian"
                  :state="!$v.model.uraian.$error"
                ></b-form-textarea>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                <b-input-group-append>
                  <div class="text-center">
                    <b-input-group>
                      <!-- <b-input-group-prepend
                        ><span class="p-2"
                          >Add Trx. after save</span
                        ></b-input-group-prepend
                      >
                      <b-form-checkbox
                        v-model="inputBerlanjut"
                        :value="1"
                        :unchecked-value="0"
                        class="pt-2"
                      ></b-form-checkbox> -->
                      <b-input-group-append>
                        <button
                          v-if="saveEnabled"
                          class="btn btn-primary mr-1"
                          @click="save()"
                        >
                          <i class="fa fa-save"></i> Disbursement
                        </button>
                      </b-input-group-append>
                      <b-input-group-append>
                        <button class="btn btn-primary mr-1" @click="close()">
                          <i class="fa fa-close"></i> Close
                        </button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="lkuCashflowShow"
      size="lg"
      :hide-footer="true"
      title="List of Cashflow Account"
      :centered="true"
    >
      <lku-cashflow @click="onSelectLkuCashflow"></lku-cashflow>
    </b-modal>
    <b-modal
      v-model="lkuBankaccountShow"
      size="lg"
      :hide-footer="true"
      title="List of Bank/Cash Account"
      :centered="true"
    >
      <lku-bankaccount
        @click="onSelectLkuBankaccount"
        :isbank="bankOnly"
        :key="bankOnly"
      ></lku-bankaccount>
    </b-modal>
    <b-modal
      v-model="confirmPelunasanBthpShow"
      title="Konfirmasi"
      :centered="true"
      @ok="confirmPelunasanBertahap('Yes')"
      @cancel="confirmPelunasanBertahap('No')"
    >
      <p class="my-2">Pinjaman ini pelunasan bertahap/langsung</p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>
<style lang="scss">
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}

.my-number{
  min-width:100px;
}

.label-md{
  width:150px !important;
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
// import vDim from "../lookup/dim";
import lkuPinjamanoutstand from "./lkuPinjamanoutstand";
import lkuPinjaman from "./lkuPinjamanBlmLunas";
import lkuBankaccount from "../lookup/lkuBankaccount";
import lkuCashflow from "../lookup/lkuCashflow";
import lkuCustomer from "./lkuDebitur";
// apis library
import arpayment from "../../apis/pinjamanpayment";
import crud from "../../apis/crud";
import refundfin from '../../apis/refundfin';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  requiredUnless,
  minValue,
  minLength,
  numeric,
} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {
    myNumber,
    lkuPinjamanoutstand,
    lkuPinjaman,
    lkuBankaccount,
    lkuCashflow,
    lkuCustomer,
    Loading
  },
  mixins: [validationMixin],
  validations: {
    model: {
      settleKey: { required },
      disburmentamt:{required, minValue: minValue(0.01)},
      uraian: { required },
      tglpaym: { required },
      jenis: { required },
      tgl_terima: {
        required: function () {
          if (this.model.jenis !== "Cheque" && this.model.jenis !== "Giro") {
            return true;
          } else if (this.model.tgl_terima) {
            return true;
          } else return false;
        },
      },
      namabank:{ required },
      matauang: { required },
      kurstrx: { required, minValue: minValue(0.00000001) },
    },
  },
  data() {
    return {
      isLoading:false,
      arGroups: [],
      collectors: [],
      paym_group: [
        { text: "Normal", value: "NM" },
        { text: "WO", value: "WO" },
      ],
      selectedPinjamanOS: [],
      selectedPinjaman:[],
      currency: [{ value: "IDR", text: "IDR" }],
      potongans: [],
      saveEnabled: true,
      horizontal: true,
      jenisPaym: ["Cheque", "Giro", "Transfer", "Tunai"],
      model: {
        trxno:"",
        jenis: "Transfer",
        kodecash: "",
        kodebank: "",
        kurstrx: 1,
        tglpaym: this.$store.state.timeServer,
        tgl_terima: this.$store.state.timeServer,
        // tgl_terima:moment().format("YYYY-MM-DD"),
        disburmentamt: 0,
        totaldiskon: 0,
        matauang: "",
        totalbyr: "",
        custcode:"",
        CustName:"",
        customer_id: "",
        collector_id:"",
        settl_amt: 0,
        paym_group: "NM",
        pelunasan_bertahap:0,
        ismemo: 0,
        namabank:''
      },
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lblExchRate: "Exch. Rate ",
      bankOnly: 1,
      lkuBankaccountShow: false,
      lkuCashflowShow: false,
      lkuCashflowCaller: "arpaymdt",
      totalDtlPaym: 0,
      updateDimHdr: false,
      updateDimDtl: true,
      arpaymdt: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "no_kontrak",
            label: "No. Kontrak",
            thStyle: "width:140px",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Uraian Pinjaman",
            sortable: true,
          },
          {
            key: "angsuran_ke",
            label: "Angsuran ke-",
            thStyle: "width:60px",
            sortable: true,
          },
          {
            key: "tgl_jttempo",
            thStyle: "width:90px",
            label: "Tgl. Jt.Tempo",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "nilaisettl_desc",
            label: "Jenis Settlement",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nilaisettl",
            label: "Nilai Settlement",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilaibank",
            label: "Nilai Cash/Bank",
            thStyle: "width:142px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidiskon",
            label: "Nilai Diskon",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "cashflow",
            label: "Cashflow Acc.",
            sortable: true,
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 90,
        total: 0,
      },
      arpaymdtObj: {
        pinjamankey: "",
        kodecash: "",
        nilaisettl_desc: "POKOK",
        nilaidiskon: 0,
        nilaibank: 0,
        nilaisettl: 0,
      },
      lkuPinjamanoutstandShow: false,
      lkuPinjamanShow: false,
      addPrincipInterest: false,
      lkuPinjamanoutstandData: {},
      lkuCustomerShow: false,
      confirmPelunasanBthpShow: false,
      pelunasanbertahap: false,
      selectedOSPinjaman :{},
      tabIndex: 0,
      minpay: 0,
      items:[],fields: ['first_name', 'last_name', 'age']
    };
  },
  computed: {
    uanguser() {
      return this.$store.state.user.matauang;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    // dimension(){
    //   return this.$store.state.dimension;
    // },
    caraBayar() {
      return this.model.jenis;
    },
    bankkas() {
      return this.model.kodebank;
    },
    adaPotongan() {
      return (this.arpaymdtObj.nilaidiskon || 0) != 0;
    },
    nilaisettl_desc() {
      return this.arpaymdtObj.nilaisettl_desc;
    },
    adaNilaiBank() {
      return (this.arpaymdtObj.nilaibank || 0) != 0;
    },
    adaNilaiDiskon() {
      return this.model.paym_group == "WO";
    }
  },
  watch: {
    "model.paym_group": function (newVal) {
      this.model.wo_status = newVal == "WO" ? 1 : 0;
    },
    caraBayar: function (jenis) {
      if (jenis === "Tunai") {
        this.bankOnly = "0";
      } else {
        this.bankOnly = "1";
      }
      if (!this.bankOnly) {
        this.model.kodebank = "";
        this.model.namabank = "";
      }
    },
    bankkas: function (kode) {
      if (this.uanguser.trim() == this.model.matauang.trim()) {
        this.model.kurstrx = 1;
      }
    },
    nilaisettl_desc: function (kode) {
      let pot = this.potongans.find((r) => r.value === kode);
      if (pot) {
        this.arpaymdtObj.Potongan = pot.text;
      }
    },
    "model.tglpaym": function (newVal) {
      if(!this.$route.params.arpaymKey){
        this.model.tgl_terima=moment(newVal).format("YYYY-MM-DD");
      }
    }
  },
  created: async function () {
    this.model.matauang = this.uanguser;
    if (this.$route.params.settleKey) {
      const data = await refundfin.detail(this.$route.params);
      this.model.settleKey = data.settleKey;
      this.model.settleno = data.settleno;
      this.model.tglsettl = moment(data.tglsettl).format('DD MMMM YYYY');
      this.model.custinfo = `${data.CustCode} | ${data.CustName}`;
      this.model.CustCode = data.CustCode;
       this.model.CustName = data.CustName;
      this.model.pinjamankey = data.pinjamankey;
      this.model.customer_id = data.customer_id;
      this.model.collector_id = data.collector_id;
      this.model.no_agreement = data.no_agreement;
      this.model.no_kontrak = data.no_kontrak;
      this.model.paym_group = data.paym_group;
      this.model.settleuraian = data.settleuraian;
      this.model.settleamt = data.settleamt;
      this.model.disburmentamt = data.settleamt;
      this.model.uraian = `Disburment ${data.settleuraian}`;
    }else if (this.$route.params.disburmentKey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        const [a, d, e, data] = await Promise.all([
          arpayment.currency(),
          await arpayment.potongan(),
          crud.list({
            tablename: "vwcollector",
            page: 1,
            limit: 1000,
            sortBy: "collector_name",
            sortDesc: false,
          }),
          refundfin.disburmentdetail(this.$route.params),
        ]);
        this.currency = a;
        // this.arGroups = c;
        this.potongans = d;
        this.collectors = e.reduce((newArr, item) => {
          newArr.push({ value: item.collector_id, text: item.collector_name });
          return newArr;
        }, []);
        const row = data;
        this.saveEnabled = row.posting === 0;
        row.tglpaym = row.tglpaym
          ? moment(row.tglpaym).format("YYYY-MM-DD")
          : "";
        row.tgl_giro = row.tgl_giro
          ? moment(row.tgl_giro).format("YYYY-MM-DD")
          : "";
        row.tgl_terima = row.tgl_terima
          ? moment(row.tgl_terima).format("YYYY-MM-DD")
          : "";

        for (var key in row) {
          this.model[key] = row[key];
        }
        this.model.pinjamaninfo=`${row.no_agreement}`
        this.model.disburmentamt = data.disburment_amt;
        this.model.tglsettl = moment(data.tglsettl).format('DD MMMM YYYY');
        this.model.custinfo = `${data.CustCode||data.custcode} | ${data.CustName}`;
        this.model.isbank = data.nomorrek?true:false;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      // const [a,c,d,e] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
      //                 crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false})]) ;
      // this.currency = a;
      // this.arGroups = c;
      // this.potongans = d;
      //     this.collectors = e.reduce((newArr,item) =>{
      //         newArr.push({ value: item.collector_id, text: item.collector_name});
      //         return newArr;
      //     },[]);\
      const collectors = await crud.list({
        tablename: "vwcollector",
        page: 1,
        limit: 0,
        total: 0,
        sortBy: null,
        sortDesc: false,
      });

      this.collectors = collectors.reduce(function (arr = [], item) {
        arr.push({
          value: item.collector_id,
          text: item.collector_name,
        });
        return arr;
      }, []);
      this.collectors.unshift({
        value: "",
        text: "-- Pilih salah satu --",
        disabled: true,
      });
      this.model.tglpaym = this.model.tglpaym
        ? moment(this.model.tglpaym).format("YYYY-MM-DD")
        : "";
    }
  },
  methods: {
    showLkuCashflow(callerObj) {
      this.lkuCashflowShow = true;
      this.lkuCashflowCaller = callerObj;
    },
    onSelectLkuCashflow(_selected) {
      this.arpaymdtObj.cashflow =
        _selected.kodecash.trim() + " | " + _selected.namacash.trim();
      this.arpaymdtObj.kodecash = _selected.kodecash;
      this.arpaymdtObj.namacash = _selected.namacash;
      this.lkuCashflowShow = false;
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
    
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else if (this.totalDtlPaym > parseFloat(this.model.totalbyr)) {
        toastr.error(
          "[Total Settle. pembayaran] not Balance with [Total Detail Payment]",
          "ERROR MESSAGE"
        );
      } else {
        try {
          this.isLoading=true;
          this.model.paymno = this.model.paymno || "";
          this.model.statusar = this.model.statusar || 0;
          this.model.statustre = this.model.statustre || 0;
          this.model.totalbyr = this.model.totalbyr || 0;
          this.model.totalbank = this.model.totalbank || 0;
          this.model.totaldiskon = this.model.totaldiskon || 0;
          this.model.bcharge = this.model.bcharge || 0;
          
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.tglpaym = moment(row.tglpaym).format("YYYY-MM-DD");
          row.tgl_giro = row.tgl_giro
            ? moment(row.tgl_giro).format("YYYY-MM-DD")
            : undefined;
          row.tgl_terima = row.tgl_terima
            ? moment(row.tgl_terima).format("YYYY-MM-DD")
            : moment(row.tglpaym).format("YYYY-MM-DD");
         
          const result = await refundfin.disburmentsave(row);
          toastr.success(
            `Trx. No : ${result.trxno} ,Complete successfully`,
            "Save Disburment"
          );
          this.isLoading=false;
          if (this.inputBerlanjut == 0) {
            const arpaylist={};
            const filter = this.$store.state.filter;
            arpaylist.tgl1=  moment(row.tglpaym).format("YYYY-MM-DD");
            arpaylist.tgl2=  moment(row.tglpaym).format("YYYY-MM-DD");
            filter.arpaylist=arpaylist;
            this.$store.commit("filter", filter);
            this.close();
          } else {
            this.saveEnabled = true;
            const jenis = this.model.jenis;
            for (var key in this.model) {
              this.model[key] = "";
            }
            this.model.jenis = jenis;
            this.model.matauang = this.$store.state.user.matauang;
            this.model.kurstrx = 1;
            this.model.settl_amt = 0;
            this.model.tglpaym = moment().format("YYYY-MM-DD");
            this.totalDtlPaym = 0;
            for (var key in this.arpaymdtObj) {
              this.arpaymdtObj[key] = "";
            }
            this.arpaymdt.items = [];
            this.arpaymdt.total = 0;
            this.calcTotalDtlPaym();
            this.$v.model.$reset();
          }
        } catch (error) {
          this.isLoading=false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    closeArPayment: function () {
      const opened = this.arpaymdt.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addPaymLoan: function () {
      this.lkuPinjamanoutstandShow = true;
      this.addPrincipInterest = true;
    },
    updateNilaibank: function () {
      if (this.model.matauang == this.arpaymdtObj.matauang) {
        this.arpaymdtObj.nilaibank =
          this.arpaymdtObj.nilaisettl - (this.arpaymdtObj.nilaidiskon || 0);
      }
    },
    onSelectLkuBankaccount(_selected) {
      this.model.kodebank = _selected.kode;
      this.model.matauang = _selected.matauang;
      this.model.namabank = _selected.namabank;
      this.model.nomorrek = _selected.nomorrek;
      this.model.isbank = _selected.isbank;
      this.lkuBankaccountShow = false;
    },
    // updateDimDtl2Hdr: function (dimDtl) {
    //     var dimHdr = this.model;
    //     this.dimension.forEach((dim) => {
    //         if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
    //             dimHdr[dim.value] = dimDtl[dim.value];
    //             dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
    //             dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimHdr = !this.updateDimHdr;
    // },
    // updateDimHdr2Dtl: function (dimDtl) {
    //     var dimHdr = this.model;
    //     dimDtl = dimDtl || this.othPayment.obj;
    //     this.dimension.forEach((dim) => {
    //         if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
    //             dimDtl[dim.value] = dimHdr[dim.value];
    //             dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
    //             dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimDtl = !this.updateDimDtl;
    // },
    calcTotalDtlPaym: function () {
      let totalDtlPaym = this.model.bcharge || 0;
      let totalDtlBank = this.model.bcharge || 0;
      let totalDtlDiskon = 0;
      totalDtlPaym = totalDtlPaym || 0;
      this.arpaymdt.items.forEach(function (trx) {
        if (trx.pinjamankey) {
          totalDtlPaym =
            totalDtlPaym +
            parseFloat(trx.nilaibank) +
            parseFloat(trx.nilaidiskon);
          totalDtlDiskon = totalDtlDiskon + parseFloat(trx.nilaidiskon);
          // totalDtlBank = totalDtlBank + parseFloat(trx.nilaibank);
        }
      });
      this.totalDtlPaym = totalDtlPaym;
      this.model.totalbyr = totalDtlPaym;
      this.totalDtlBank = totalDtlBank;
      // this.model.totalbank = totalDtlBank;
      this.totalDtlDiskon = totalDtlDiskon;
      this.model.totaldiskon = totalDtlDiskon;
    },
    // close(){
    //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.arpaymfrm'))  {
    //     router.push({name:'receivable.arpaymlist'});
    //   } else {
    //     router.push({name:'receivable.home'});
    //   }
    // }
    close() {
      router.push({ name: "loan.refunddisbursementlist" });
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
  },
};
</script>
